import {
  GET_ALL_REGISTERED_CM_ICA,
  GET_ALL_REGISTERED_CM_SUCCESS_ICA,
  GET_ALL_REGISTERED_CM_FAILURE_ICA,

  GET_CM_ICA_BY_ID,
  GET_CM_ICA_BY_ID_SUCCESS,
  GET_CM_ICA_BY_ID_FAILURE,
  GET_CM_ICA_BY_ID_RESET,

  EXPORT_CM_TRAINING,
  EXPORT_CM_TRAINING_SUCCESS,
  EXPORT_CM_TRAINING_FAILURE,
  EXPORT_CM_TRAINING_RESET,

  GET_ALL_ICA_NO_PAGINATION,
  GET_ALL_ICA_NO_PAGINATION_SUCCESS,
  GET_ALL_ICA_NO_PAGINATION_FAILURE,
  GET_ALL_ICA_NO_PAGINATION_FAILURE_RESET
} from "../ActionTypes"

export const getAllRegisteredCmIca = (payload) => ({
  type: GET_ALL_REGISTERED_CM_ICA,
  payload
})

export const getAllRegisteredCmSuccessIca = (payload) => ({
  type: GET_ALL_REGISTERED_CM_SUCCESS_ICA,
  payload
})

export const getAllRegisteredCmFailureIca = (payload) => ({
  type: GET_ALL_REGISTERED_CM_FAILURE_ICA,
  payload
})


export const getCmIcaById = payload => ({
  type: GET_CM_ICA_BY_ID,
  payload
})

export const getCmIcaByIdSuccess = payload => ({
  type: GET_CM_ICA_BY_ID_SUCCESS,
  payload
})

export const getCmIcaByIdFailure = payload => ({
  type: GET_CM_ICA_BY_ID_FAILURE,
  payload
})

export const getCmIcaByIdReset = payload => ({
  type: GET_CM_ICA_BY_ID_RESET,
  payload
})

export const exportCmTraining = payload => ({
  type: EXPORT_CM_TRAINING,
  payload
})

export const exportCmTrainingSuccess = payload => ({
  type: EXPORT_CM_TRAINING_SUCCESS,
  payload
})

export const exportCmTrainingFailure = payload => ({
  type: EXPORT_CM_TRAINING_FAILURE,
  payload
})

export const exportCmTrainingReset = payload => ({
  type: EXPORT_CM_TRAINING_RESET,
  payload
})

export const getAllIcaNoPagination = payload => ({
  type: GET_ALL_ICA_NO_PAGINATION,
  payload
})

export const getAllIcaNoPaginationSuccess = payload => ({
  type: GET_ALL_ICA_NO_PAGINATION_SUCCESS,
  payload
})

export const getAllIcaNoPaginationFailure = payload => ({
  type: GET_ALL_ICA_NO_PAGINATION_FAILURE,
  payload
})

export const getAllIcaNoPaginationFailureReset = () => ({
  type: GET_ALL_ICA_NO_PAGINATION_FAILURE_RESET
})